// extracted by mini-css-extract-plugin
module.exports = {"inner":"EditorFooter_inner__3TEGx","errorLogs":"EditorFooter_errorLogs__3lxxs"};